<template>
  <div class="order-item-summary">
    <div class="heading">
      <div class="meal-name">
        <h5 class="category-type-name text-uppercase">
          {{ item.displayName }}
        </h5>
      </div>
      <h5 v-if="item.subTotal" class="line-item-total">
        {{ item.subTotal | toCurrency }}
      </h5>
    </div>
    <div v-if="item.displaySubName">
      <span class="sub-item-name">{{ item.displaySubName }}</span>
      <span class="sub-item-info">– {{ getTagline(item.menuId) }}</span>
    </div>
    <div class="collapsed-content" v-if="dense === false">
      <div class="description">{{ item.servesText }}</div>
      <div
        v-for="categoryItem in subItemCategories"
        :key="categoryItem.name"
        class="category"
      >
        <div class="category-item-name">{{ categoryItem.name }}</div>
        <span class="build-item">
          {{ categoryItem.itemsText }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import * as menuConstants from '@/menu'
import { orderSummaryMixin } from '@/mixins/orderSummary'

const menuCategoryNameMap = {
  [menuConstants.CATEGORY_BASE]: 'Bases',
  [menuConstants.CATEGORY_PROTEIN]: 'Proteins',
  [menuConstants.CATEGORY_TOPPING]: 'Toppings',
  [menuConstants.CATEGORY_PREMIUM]: 'Premium Toppings',
  [menuConstants.CATEGORY_SALSA]: 'Salsas',
  [menuConstants.CATEGORY_TORTILLA]: 'Tortillas',
}

export default {
  props: {
    item: Object,
    mealName: String,
    dense: Boolean,
  },
  mixins: [orderSummaryMixin],
  computed: {
    subItemCategories() {
      const menuCategoryItemHash = {}
      const result = []
      this.item.subItems.forEach((si) => {
        if (si.quantity <= 0) {
          return
        }

        const menuCategory = menuConstants.MenuCategory[si.menuId]
        if (menuCategory) {
          menuCategoryItemHash[menuCategory] =
            menuCategoryItemHash[menuCategory] || []
          menuCategoryItemHash[menuCategory].push(si.name)
        }
      })

      for (const categoryId in menuCategoryNameMap) {
        if (menuCategoryItemHash[categoryId]) {
          result.push({
            name: menuCategoryNameMap[categoryId],
            itemsText: menuCategoryItemHash[categoryId].join(', '),
          })
        }
      }
      return result
    },
  },
}
</script>
<style lang="scss">
.order-item-summary {
  .meal-name {
    display: flex;
  }
  .category {
    margin-bottom: 15px;
  }
  .category-type-name {
    font-weight: 700;
    color: $headings-color;
    font-family: $font-family-sans-serif;
    font-size: 18px;
  }
  .category-item-name {
    font-weight: 700;
    color: $headings-color;
    font-family: $font-family-helvetica;
  }
  .build-item {
    font-family: $font-family-helvetica;
    color: $catering-light-grey-brown;
  }
  .heading {
    display: flex;
    justify-content: space-between;
  }
  .description {
    margin-bottom: 15px;
    font-family: $font-family-helvetica;
    color: $catering-light-grey-brown;
  }
  h5,
  h4 {
    margin: 0;
  }
  .line-item-total {
    font-family: $font-family-helvetica;
    font-size: 18px;
  }
  .sub-item-name {
    font-size: 18px;
    font-family: $font-family-sans-serif;
    font-weight: 700;
    color: $headings-color;
  }
  .sub-item-info {
    font-family: $font-family-helvetica;
    color: $headings-color;
  }
}
</style>
